"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OraclePropertiesFactoryFromJS = exports.OraclePropertiesFactory = void 0;
const immutable_1 = require("immutable");
const IOracle_1 = require("../credentials/IOracle");
exports.OraclePropertiesFactory = (0, immutable_1.Record)({
    credentials: (0, IOracle_1.OracleCredentialsFactory)(),
    connectionString: '',
    database: '',
    server: ''
});
const OraclePropertiesFactoryFromJS = function (data) {
    return (0, exports.OraclePropertiesFactory)({
        credentials: (0, IOracle_1.OracleCredentialsFactoryFromJS)(data.credentials),
        connectionString: data.connectionString,
        database: data.database,
        server: data.server
    });
};
exports.OraclePropertiesFactoryFromJS = OraclePropertiesFactoryFromJS;
//# sourceMappingURL=IOracleProperties.js.map